import React from 'react';
import {
  Link,
} from 'react-router-dom';
import './Sec1.css';

const Services = () => (
  <div>
    <br /><br />
    <h2>Services</h2>
    <ul>
      <li>
        <Link to='/internet' style={{ textDecoration: 'none' }}>
          <p>Internet Service</p>
        </Link>
      </li>
      <li>
        <Link to='/phone' style={{ textDecoration: 'none' }}>
          <p>Phone Service</p>
        </Link>
      </li>
    </ul>
  </div>
);

export default Services;


// WEBPACK FOOTER //
// ./src/components/sections/Services.js